export const language = {
  en: {
    'Confirm': 'Confirm',
    'Edit': 'Edit',
    'Save': 'Save',
    'Cancel': 'Cancel',
    'Please Entry': 'Please Entry',
    'Company Attributes': 'Company Attributes',
    'CP Group': 'CP Group',
    'Non-CP Group': 'Non-CP Group',
    'Platform Role': 'Platform Role',
    'Supplier': 'Supplier',
    'Buyer': 'Buyer',
    'Company Type': 'Company Type',
    'Whether Production Base': 'Whether Production Base',
    'Yes': 'Yes',
    'No': 'No',
    'Operation': 'Operation',
    'Add': 'Add',
    'Delete': 'Delete',

    'Category': 'Category',
    'Region': 'Region',
    'SVC Region': 'SVC Region',
    'Synchronous ERP system？': 'Synchronous ERP system？',
    'System': 'System',
    'Organization Code': 'Organization Code',
    'Store Code': 'Store Code',
    'Payment Code': 'Payment Code',
    'Procurement Organization Code': 'Procurement Organization Code',
    'Sales Organization Code': 'Sales Organization Code',
    'Warehouse': 'Warehouse',
    'Warehouse Code': 'Warehouse Code',
    'Please Entry Warehouse Code': 'Please Entry Warehouse Code',
    'None': 'None',
    'Store': 'Store',
    'Company': 'Company',
    'Group Company': 'Group Company',
    'Parent Company': 'Parent Company',
    'Warehouse System': 'Warehouse System',
    'Warehouse Name': 'Warehouse Name',
    'Warehouse Code1': 'Warehouse Code',
    'Factory Code': 'Factory Code',
    'Stock location Code': 'Stock location Code',
    'Please Entry Parent Company': 'Please Entry Parent Company',
    'Please enter warehouse_name': 'Please enter warehouse_name',
    'Please enter warehouse_code': 'Please enter warehouse_code',
    'Please enter factory_code': 'Please enter factory_code',
    'Please enter stock_location_code': 'Please enter stock_location_code',
    'Warehouse Name Duplicate': 'Warehouse Name Duplicate',
    'Warehouse Code Duplicate': 'Warehouse Code Duplicate',
    'Please Entry Warehouse Information': 'Please Entry Warehouse Information',
  },
  zh: {
    'Confirm': '确认',
    'Edit': '编辑',
    'Save': '保存',
    'Cancel': '取消',
    'Please Entry': '请输入',
    'Company Attributes': '公司属性',
    'CP Group': '正大集团',
    'Non-CP Group': '非正大集团',
    'Platform Role': '平台角色',
    'Supplier': '供应商',
    'Buyer': '采购商',
    'Company Type': '公司类型',
    'Whether Production Base': '是否基地',
    'Yes': '是',
    'No': '否',
    'Operation': '操作',
    'Add': '新增',
    'Delete': '删除',

    'Category': '经营品类',
    'Region': '战区',
    'SVC Region': 'SVC区',
    'Synchronous ERP system？': '是否同步ERP',
    'System': '系统',
    'Organization Code': '组织编码',
    'Store Code': '门店编码',
    'Payment Code': '结算组织编码',
    'Procurement Organization Code': '采购组织编码',
    'Sales Organization Code': '销售组织编码',
    'Warehouse': '大仓',
    'Warehouse Code': '仓库编码',
    'Please Entry Warehouse Code': '请输入仓库编码',
    'None': '无',
    'Store': '门店',
    'Company': '公司',
    'Group Company': '集团公司',
    'Parent Company': '上游公司',
    'Warehouse System': '仓库系统',
    'Please Entry Parent Company': '请输入上游公司',
    'Warehouse Name': '仓库名称',
    'Warehouse Code1': 'WMS仓库编码',
    'Factory Code': 'SAP工厂编码',
    'Stock location Code': 'SAP库存地点编码',
    'Please enter warehouse_name': '请输入仓库名称',
    'Please enter warehouse_code': '请输入WMS仓库编码',
    'Please enter factory_code': 'SAP工厂编码',
    'Please enter stock_location_code': 'SAP库存地点编码',
    'Warehouse Name Duplicate': '仓库名称重复',
    'Warehouse Code Duplicate': '仓库编码重复',
    'Please Entry Warehouse Information': '请填写仓库信息',
  }
};
